import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

// Connects to data-controller="offcanvas"
export default class extends Controller {
  static values = { id: String, placement: String, class: String, suffix: String, controller: String }
  
  connect() {
    if (!this.idValue) {
      return
    }

    this.offcanvasElement = document.body.querySelector(`#${this.idValue}`)
    if (this.offcanvasElement) {
      this.menu = this.offcanvasElement
      this.offcanvas = Offcanvas.getInstance(this.menu)
    }
  }

  open(event) {
    if (this.offcanvas)
      return

    this.backdrop = document.createElement("div")
    this.backdrop.classList.add("offcanvas-backdrop", "fade")
    this.backdrop.style.zIndex = "1045"
    this.backdrop.setAttribute("data-action", "click->offcanvas#close")

    this.menu = document.createElement("turbo-frame")
    this.menu.classList.add("offcanvas", `offcanvas-${this.placementValue ? this.placementValue : "end" }`)
    this.menu.setAttribute("data-controller", "offcanvas " + this.controllerValue)
    this.menu.setAttribute("data-offcanvas-id-value", event.currentTarget.dataset.turboFrame)
    this.menu.setAttribute("tabindex", "-1")

    if (this.classValue) {
      this.classValue.split(" ").forEach(c => this.menu.classList.add(c))
    } else {
      this.menu.classList.add("w-100", "h-100", "border-0", "pt-safe-area", "pb-safe-area")
    }

    this.menu.id = event.currentTarget.dataset.turboFrame
    this.menu.innerHTML = `
      <div class="offcanvas-header placeholder-glow">
        <button type="button" class="btn-arrow" data-bs-dismiss="offcanvas" data-action="offcanvas#close" aria-label="Close"></button>
        <h5 class="offcanvas-title fs-6 fw-bold position-absolute start-50 translate-middle-x placeholder">Roading...</h5>
      </div>
      <div class="offcanvas-body"></div>
    `
    document.body.appendChild(this.menu)

    this.offcanvas = new Offcanvas(this.menu, {
      backdrop: false,
      scroll: false,
      keyboard: true
    })

    this.menu.addEventListener('shown.bs.offcanvas', function () {
      document.body.style.overflow = "hidden"
    })

    this.menu.addEventListener("hide.bs.offcanvas", () => {
      this.backdrop.classList.remove("show")
    })

    this.menu.addEventListener("hidden.bs.offcanvas", () => {
      document.body.style.overflow = ""
      this.backdrop.remove()
      this.offcanvas.dispose()
      this.menu.remove()
      this.offcanvas = null
    })

    this.backdrop.addEventListener("click", () => this.close())

    this.backdrop.classList.add("show")
    this.menu.insertAdjacentElement("beforebegin", this.backdrop)
    this.offcanvas.show()
  }

  close(event) {
    if(event.detail == 1 || event.detail.success)
      this.offcanvas.hide()
  }

  preventScroll(event) {
    event.preventDefault();
  }
}
